/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import Now from 'shared/query/current.time';
import Url from 'shared/client/url';
import Galaxy from 'shared/query/galaxy';
import Navigation from 'shared/client/navigation';

import BuildingEnum from 'galax/enum/building';
import ShapeEnum from 'shared/enum/shape';

import * as Coords from 'shared/geo/coords';


export default new Client([ Navigation, Galaxy, Url, Now ], class
{
  constructor (navigation, galaxy, url, now)
  {
    this.now = now;

    this.galaxy = galaxy;
    this.navigation = navigation;

    this.source = navigation.getCurrent();
    this.target = navigation.getRawTarget();

    this.args = url.getRoute().getArgs();
  }


  onDone ()
  {
    if (this.args.type === BuildingEnum.Gate)
    {
      const shape = this.navigation.getBehaviorShape();

      this.galaxy.createBuildingWithTarget(this.source, this.args.type, this.target, shape);
    }
    else
    {
      this.galaxy.createBuilding(this.source, this.args.type);
    }
  }


  getError ()
  {
    const type = this.args.type;
    const zone = this.source.getZone();

    if (type == null)
    {
      return 'No building type found';
    }

    if (!zone.getCass().isCenter())
    {
      return 'Building has to be constructed in the sector\'s center';
    }

    if (zone.getSector().getBuilding() != null)
    {
      return 'Sector can only have one building';
    }

    const constants = this.galaxy.getConstants().getBuilding(type);

    const userResources = this.source.getUser().getResources(this.now); // TODO needs to use global user - this is tricky access...
    const buildingResources = constants.getConstructionResources();

    if (userResources.carbon < buildingResources.carbon || userResources.silicon < buildingResources.silicon || userResources.hydrogen < buildingResources.hydrogen)
    {
      return 'You don\'t have enough resources to construct';
    }

    if (zone.getPlanet().getEntities().getActiveConstruction(zone.getUserID()))
    {
      return 'One building construction / upgrade per planet';
    }

    if (type === 'spaceport' && zone.getSector().getNeighbors().getMaybeDocks().length === 0)
    {
      return 'Spaceport requires access to planet edge';
    }

    // TODO gate specific checks
    if (type === BuildingEnum.Gate)
    {
      if (this.source.equals(this.target))
      {
        return 'Unit cannot attack zone it occupies.';
      }

      const distance  = Coords.getDistance(this.source.getCoords(), this.target.getCoords());

      if (distance > 10)
      {
        return 'Target zone is out of range. Please select a closer target.';
      }

      for (const target of this.navigation.getFullTargets())
      {
        if (target.location.getPlatform() || target.location.getZone())
        {
          return 'Needs an empty zone to create platform.';
        }
      }
    }

    return null;
  }


  getInitial (target)
  {
    if (this.args.type === '')
    {
      return 'Select building type';
    }

    if (this.args.type === BuildingEnum.Gate)
    {
      if (this.target == null)
      {
        return 'Select target zone';
      }
    }

    return null;
  }


});
